export interface PersistenceProvider {
  load(): string | null;
  save(raw: string): void;
  clear(): void;
}

export const SAVE_STORAGE_KEY = 'park_v1_wu001_save';

export class LocalStoragePersistence implements PersistenceProvider {
  constructor(private readonly key: string = SAVE_STORAGE_KEY) {}

  load(): string | null {
    try {
      return window.localStorage.getItem(this.key);
    } catch {
      return null;
    }
  }

  save(raw: string): void {
    try {
      window.localStorage.setItem(this.key, raw);
    } catch {
      // Ignore quota / private-mode failures; gameplay continues unsaved.
    }
  }

  clear(): void {
    try {
      window.localStorage.removeItem(this.key);
    } catch {
      // ignore
    }
  }
}
